export function ViewLoading() {
    return (
        <div className='container d-flex flex-column align-items-center gap-4' role='alert'>
            <div className="d-flex justify-content-center">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden" style={{ color: 'black' }}>Loading...</span>
                </div>
            </div>
            <span>Cargando...</span>
        </div>
    )
}
